/**
 * @generated SignedSource<<adc5d640ae28ff033c3065f0ab7f8457>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePoliticalViewCriteria_query$data = {
  readonly currentUser: {
    readonly politicalViewCriteria: {
      readonly nodes: ReadonlyArray<{
        readonly politicalViewId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "usePoliticalViewCriteria_query";
};
export type usePoliticalViewCriteria_query$key = {
  readonly " $data"?: usePoliticalViewCriteria_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePoliticalViewCriteria_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePoliticalViewCriteria_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "POLITICAL_VIEW_BY_POLITICAL_VIEW_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "PoliticalViewCriterionConnection",
          "kind": "LinkedField",
          "name": "politicalViewCriteria",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PoliticalViewCriterion",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "politicalViewId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "politicalViewCriteria(orderBy:[\"POLITICAL_VIEW_BY_POLITICAL_VIEW_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "361e70f9069c0d646b24ad6119230274";

export default node;
